import { render, staticRenderFns } from "./OrderedList.vue?vue&type=template&id=059ec20a&scoped=true"
import script from "./OrderedList.vue?vue&type=script&lang=js"
export * from "./OrderedList.vue?vue&type=script&lang=js"
import style0 from "./OrderedList.vue?vue&type=style&index=0&id=059ec20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059ec20a",
  null
  
)

export default component.exports